var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bounce","appear":""}},[_c('h1',[_vm._v("NOT FOUND PAGE")])])}
var staticRenderFns = []

export { render, staticRenderFns }